import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromRolePermissions from './role-permissions.reducer'
import { RolePermissionsGeneralTabComponent } from './general-tab/show.component'
import { RolePermissionsIndexComponent } from './index/index.component'
import { RolePermissionsEffects } from './role-permission.effects'
import { RolePermissionsSerializer } from './role-permissions.serializer'
import { RolePermissionsService } from './role-permissions.service'
import { RolePermissionsShowComponent } from './show/show.component'
import { RolePermissionsTableComponent } from './table/table.component'
import { RolePermissionsRoutingModule } from './role-permissions-routing.module'
import { RolePermissionsCreateComponent } from './create/show.component'
import { RolePermissionsFormComponent } from './form/form.component'
import { ConfigurationOptionShopTilesTabComponent } from '../configuration-option/shop-tiles-tab/show.component'
import { ConfigurationOptionModule } from '../configuration-option/configuration-option.module'
import { ProductSelectInput } from '../product/product-select-input/show.component'
import { ProductModule } from '../product/product.module'
import { ShowModalModule } from './show-modal/ShowModal.module'

@NgModule({
  imports: [
    RolePermissionsRoutingModule, // must be before other modules with routes
    SharedModule,
    ConfigurationOptionModule,
    StoreModule.forFeature(
      fromRolePermissions.FEATURE_NAME,
      fromRolePermissions.rolePermissionsReducer
    ),
    EffectsModule.forFeature([RolePermissionsEffects]),
    ProductModule,
    ShowModalModule
  ],
  declarations: [
    RolePermissionsIndexComponent,
    RolePermissionsTableComponent,
    RolePermissionsShowComponent,
    RolePermissionsGeneralTabComponent,
    RolePermissionsCreateComponent,
    RolePermissionsFormComponent
  ],
  exports: [RolePermissionsTableComponent],
  providers: [
    RolePermissionsService,
    {
      provide: RolePermissionsSerializer,
      useClass: RolePermissionsSerializer
    }
  ]
})
export class RolePermissionsModule {}
